function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

if (localStorage.getItem("wholesales") == "true") {
  details = JSON.parse(localStorage.getItem("wholesales-details"));
  $(".tt-product-single-info").show();
  $(".tt-dropdown-inner")
    .eq(1)
    .html(
      `<h5 style="margin-bottom: -15px;">Hello, ${details["picName"]}</h5> <h6>@ ${details["cafeName"]}</h6> <ul> <li><a href="#" onclick="logout()">Log out</a></li> </ul>`
    );
var $wholesaleDropdown = $(".dropdown").filter(function() {
  return $(this).find("a").text().trim() === "Wholesale";
});
$wholesaleDropdown.find("a")
  .attr("href", "https://ghostbirdcoffee.co/collections/wholesale")
  .css({
    "font-weight": "bold",
    "color": "red"
  });
$wholesaleDropdown.insertBefore($(".tt-megamenu-col-01").eq(0));
} else {
  if (location.pathname.includes("-ws")) {
    location.replace("https://ghostbirdcoffee.co");
  } else if (location.pathname == "/collections/wholesale") {
    location.replace("https://ghostbirdcoffee.co");
  }

  setInterval(function () {
    $(".tt-col-item").each(function () {
      let ws_item = false;
      try {
        ws_item = $(this).find(".tt-title").find("a").attr("href").includes("-ws");
      } catch {}
      if (ws_item) {
        $(this).remove();
      }
    });
  }, 100);
}

function logout() {
  localStorage.setItem("wholesales", "false");
  location.replace("https://ghostbirdcoffee.co/");
}
